module.exports = __webpack_public_path__ + "img/pray.95a62bdb.gif";